var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.cookieAck
    ? _c("div", { staticClass: "cookie-banner grid grid__base" }, [
        _c("div", { staticClass: "cookie-banner--row  grid--row" }, [
          _c("div", { staticClass: "cookie-banner--text-col grid--col" }, [
            _c(
              "p",
              { staticClass: "u-reset cookie-banner--description" },
              [
                _vm._t("default", [_vm._v(_vm._s(_vm.message))]),
                _vm._v(" \n                "),
                _c(
                  "a",
                  {
                    staticClass:
                      "u-reset cookie-banner--privacy-link link link__base link__no-underline",
                    attrs: { href: _vm.settingsUrl }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.privacyLinkLabel) +
                        "\n                "
                    )
                  ]
                )
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cookie-banner--submit-col grid--col" },
            [
              _vm._t("form"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "cookie-banner--submit btn btn__even-smaller btn__has-grid btn__primary-green",
                  on: { click: _vm.onConfirm }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.buttonLabel) +
                      "\n            "
                  )
                ]
              )
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ee62632", { render: render, staticRenderFns: staticRenderFns })
  }
}